import {
  nFormatter,
  createSeries,
  createSQL,
  seriesHead,
  appendAggregateValues,
  seriesDataItem,
  pickItem,
  isDateTransformation,
  highestModel,
  averageModel,
  missingValuesModel,
  resolve,
  getSeriesColors,
  extractColors
} from "@/components/charts/common";

import {createDataSource} from '@/models/data-source';


export default function hydrator(parameters, data, chart) {

  const dataSource = createDataSource({});
  dataSource.updateType = "api";

  data.template = resolve("template.value", parameters);
  data.style = resolve("style.value", parameters);
  let extractedColors = extractColors(resolve("colors.value", parameters));
  data.colors = getSeriesColors(extractedColors);


  try {
    const sqlQuery = parameters.sqlQuery.value;

    chart.next = async function(id) {
      try {
        const nextQuery = "SELECT id FROM (" + sqlQuery + ") AS sub9086 WHERE id > " + id + " ORDER BY id ASC LIMIT 1";
        const params = {sql: nextQuery, id: 9000000009};
        const result = await dataSource.request(params);
        console.log("data", data);
        const nextId = result.data[0].id;
        return nextId;
      } catch(err) {

      }
    
      return null;
      
      // console.log("next", data);
    }

    chart.prev = async function(id) {
      try {
        const prevQuery = "SELECT id FROM (" + sqlQuery + ") AS sub9086 WHERE id < " + id + " ORDER BY id DESC LIMIT 1";
        const params = {sql: prevQuery, id: 9000000009};
        const result = await dataSource.request(params);
        const prevId = result.data[0].id;
        return prevId;
      } catch(err) {

      }

      return null;
      
    }


  } catch(err) {
    console.log("next prev error");
  }
  
}
